import React, {Component} from "react";
import {injectIntl} from "react-intl";
import SADropdown from "../../common/dropdown/SADropdown";
import Constants from "../../../services/Constants";

import "./TiresExchange.css";

class TiresExchange extends Component {

  componentWillMount() {
    const {tiresExchange: {type = Constants.TIRE_EXCHANGE_TYPE[0].value, mode = Constants.TIRE_EXCHANGE_MODE[0].value} = {}} = this.props;
    const defaultTiresExchange = {type, mode};
    this.onUpdate(defaultTiresExchange, true);
  }

  onUpdate = (tiresExchange, pristine) => this.props.onChange(tiresExchange, pristine);

  onDropdownUpdate = (e) => {
    const {tiresExchange} = this.props;
    const {target: {name, value}} = e;
    tiresExchange[name] = value;
    this.onUpdate(tiresExchange);
  };

  render() {
    const {intl:{formatMessage}, tiresExchange, canWrite, disableType} = this.props;

    return (
        <div className="box__body appointment-tires-infos">
          <header className="d-flex justify-content-between align-items-center mb-2">
            <h3 className="box__subtitle mb-0">{formatMessage({id:'appointment.detail.services.tires-exchange.title'})}</h3>
          </header>
          <ul className="list-as-col">
            <li>
              {formatMessage({id:'appointment.detail.services.tires-exchange.type'})}: <br/>
              <SADropdown name="type" value={tiresExchange.type} onChange={this.onDropdownUpdate} disabled={!canWrite || disableType}
                          choices={Constants.TIRE_EXCHANGE_TYPE.map(c => ({value: c.value, display: formatMessage({id: c.label})}))}/>
            </li>
            <li>
              {formatMessage({id:'appointment.detail.services.tires-exchange.mode'})}: <br/>
              <SADropdown name="mode" value={tiresExchange.mode} onChange={this.onDropdownUpdate} disabled={!canWrite}
                          choices={Constants.TIRE_EXCHANGE_MODE.map(c => ({value: c.value, display: formatMessage({id: c.label})}))}/>
            </li>
          </ul>
        </div>
    );
  }
}

export default injectIntl(TiresExchange)
